<div class="find-loads-container">
    <app-find-loads-list class="load-list" (onLoadSelection)="selectLoad($event)" (onStopSelection)="selectStop($event)"
                         (onCarrierSelection)="selectCarrier($event)" (hasSelectedLoad)="preventNavigation($event)">
    </app-find-loads-list>

    <app-load-details class="load-details" [load]="selectedLoad" [stop]="selectedStop" [carrier]="selectedCarrier"></app-load-details>
</div>
